module.exports = __webpack_public_path__ + "img/16d014-28.df2c6f87.jpg";